"use strict";import{css as o}from"lit";const r=o`.divider{border-bottom:1px solid var(--color-gray-60);width:100%}`;export default r;
//# sourceMappingURL=divider.css.js.map
